import { createAsyncThunk } from '@reduxjs/toolkit'
import dateApiFormat from '../../adpaters/days/dateApiFormat'
import axios from 'axios'
import liquidationService from '../../../data/services/liquidationService'

const fetchLiquidationDownload = createAsyncThunk(
  'liquidations/export',
  async (
    { startDate, endDate, accountingStatement, sellerList, detailed },
    { signal, rejectWithValue }
  ) => {
    try {
      const source = axios.CancelToken.source()
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      const response = await liquidationService.export({
        startDate: startDate ? dateApiFormat(startDate) : undefined,
        endDate: endDate ? dateApiFormat(endDate) : undefined,
        accountingStatement: accountingStatement?.join(','),
        sellers: sellerList?.join(','),
        detailed
      })

      if (!response) {
        return rejectWithValue(
          `Descargar lista de liquidaciones falló. ${response?.message}`
        )
      }

      if (response) {
        const resJson = await response
        const blob = resJson.file

        if (blob) {
          const newBlob = new Blob([new Uint8Array(resJson.file.data)])

          const blobUrl = window.URL.createObjectURL(newBlob)

          const link = document.createElement('a')
          link.href = blobUrl
          link.setAttribute('download', `liquidaciones.xlsx`)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(newBlob)
        }

        return resJson
      } else {
        throw new Error('file not found')
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export default fetchLiquidationDownload
